import { background as baseSetBackground } from './base/index.ts';
import { SET_WINTER, background as winterSetBackground } from './wntr/index.ts';

export const COMMON_GAME_SET = SET_WINTER;

export function getSetBackground(
  name: string | undefined
): Record<'background' | 'backgroundBlendMode', string>;
export function getSetBackground(
  name: string | undefined,
  skipDefaultBackground: true
): Record<'background' | 'backgroundBlendMode', string> | undefined;
export function getSetBackground(
  name: string | undefined,
  skipDefaultBackground?: true
) {
  if (name === 'current') {
    return COMMON_GAME_SET.background;
  }
  if (name?.match(SET_WINTER.slugPattern)) {
    return winterSetBackground;
  }
  return skipDefaultBackground ? undefined : baseSetBackground;
}
